let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("t5GK3")).then(() => parcelRequire('lFpKz'));